var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.8214L2.63604 15.4575C-0.87868 11.9427 -0.87868 6.24427 2.63604 2.72955C6.15076 -0.785174 11.8492 -0.785174 15.364 2.72955C18.8787 6.24427 18.8787 11.9427 15.364 15.4575L9 21.8214ZM13.9497 14.0432C16.6834 11.3096 16.6834 6.87743 13.9497 4.14376C11.2161 1.41009 6.78392 1.41009 4.05025 4.14376C1.31658 6.87743 1.31658 11.3096 4.05025 14.0432L9 18.993L13.9497 14.0432ZM9 11.0935C7.8954 11.0935 7 10.1981 7 9.09351C7 7.98894 7.8954 7.09351 9 7.09351C10.1046 7.09351 11 7.98894 11 9.09351C11 10.1981 10.1046 11.0935 9 11.0935Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ce6d3d440406ed77d2e702648a5499ab.svg";
export { ForwardRef as ReactComponent };